import {toArray} from "lodash";
import api from "../../api/api";

const getDefaultState = () => {
    return {
        items: [],
    }
};

const state = getDefaultState();

const getters = {
    list(state) {
        return toArray(state.items);
    }
};

const actions = {
    service({commit}, payload) {
        return new Promise((resolve) => {
            api.get('/computer-gpus/' + payload.id + '/service/' + Number(payload.status)).then((result) => {
                commit('setService', result);
                resolve();
            });
        })
    }
};

const mutations = {
    setService(state, payload) {
            state.items[payload.id].status = payload.status;
    },
    set(state, payload) {
        state.items = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
